(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skylive-3d-tv"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.SkyliveTVStory) { window.SkyliveTVStory.scan(document); return; }
  var dependencies;
  function loadScript(src, ready) {
    if (ready()) return Promise.resolve();
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var timeout = setTimeout(function() { reject(new Error('Library load timed out: ' + src)); }, 20000);
      script.src = src; script.async = false;
      script.onload = function() { clearTimeout(timeout); ready() ? resolve() : reject(new Error('Library unavailable: ' + src)); };
      script.onerror = function() { clearTimeout(timeout); reject(new Error('Could not load library: ' + src)); };
      document.head.appendChild(script);
    });
  }
  function ensureDependencies() {
    if (!dependencies) {
      if (window.THREE && String(window.THREE.REVISION) !== '128') {
        return Promise.reject(new Error('Another theme script uses a different Three.js version.'));
      }
      var libs = [
        ['https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js', function() { return !!window.THREE; }],
        ['https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/GLTFLoader.js', function() { return !!(window.THREE && window.THREE.GLTFLoader); }],
        ['https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/DRACOLoader.js', function() { return !!(window.THREE && window.THREE.DRACOLoader); }],
        ['https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function() { return !!window.gsap; }],
        ['https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', function() { return !!window.ScrollTrigger; }]
      ];
      // All five download in parallel; async=false keeps them executing in this order.
      dependencies = Promise.all(libs.map(function(lib) { return loadScript(lib[0], lib[1]); }))
        .then(function() { return { THREE: window.THREE, gsap: window.gsap, ScrollTrigger: window.ScrollTrigger }; })
        .catch(function(error) { dependencies = null; throw error; });
    }
    return dependencies;
  }
  function mount(section) {
    if (section._skyliveDestroy) return;
    var destroyed = false;
    var disposeScene = function() {};
    var THREE, gsap, ScrollTrigger;
    section._skyliveDestroy = function() {
      destroyed = true;
      if (initObserver) initObserver.disconnect();
      disposeScene();
      delete section._skyliveDestroy;
    };
    function report(message) {
      section.dataset.status = message;
      console.warn('[Skylive3D] ' + message);
      if (window.Shopify && window.Shopify.designMode) {
        var status = section.querySelector('.skylive-3d-tv__status');
        if (!status) {
          status = document.createElement('p');
          status.className = 'skylive-3d-tv__status';
          status.setAttribute('role', 'status');
          status.style.cssText = 'position:absolute;bottom:24px;left:24px;right:24px;z-index:20;padding:12px;background:#000;color:#fff;font:14px/1.5 sans-serif;border:1px solid #ddd';
          section.querySelector('.skylive-3d-tv__viewport').appendChild(status);
        }
        status.textContent = message;
      }
    }

  /* ===================================================
     SKYLIVE 3D TV — SECTION CONTROLLER
     =================================================== */

  var DEBUG_3D = false;

  var SECTION_ID = section.id;
  /* ---------- CONFIG ---------- */
  var CONFIG = {
    scrollHeight: parseFloat(section.dataset.scrollHeight) || 600,
    modelScale: parseFloat(section.dataset.modelScale) || 1.0,
    modelY: parseFloat(section.dataset.modelY) || 0,
    mobileScale: parseFloat(section.dataset.mobileScale) || 0.7,
    mobileY: parseFloat(section.dataset.mobileY) || 0,
    enable3d: section.dataset.enable3d !== 'false',
    glbUrl: (section.dataset.glbUrl || '').trim()
  };

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- DOM REFS ---------- */
  var canvasEl = section.querySelector('.skylive-3d-tv__canvas');
  var loaderEl = section.querySelector('.skylive-3d-tv__loader');
  var viewportEl = section.querySelector('.skylive-3d-tv__viewport');
  var stages = {
    s1: section.querySelector('[data-stage="1"]'),
    s3: section.querySelector('[data-stage="3"]'),
    s5: section.querySelector('[data-stage="5"]'),
    final: section.querySelector('[data-stage="final"]')
  };

  /* ---------- EARLY EXIT ---------- */
  if (DEBUG_3D) console.log('[Skylive3D] Init — enable3d:', CONFIG.enable3d, '| glbUrl:', CONFIG.glbUrl);
  if (!CONFIG.glbUrl) {
    report('Add the Shopify-hosted GLB URL in this section’s GLB file URL setting. The local preview model is not uploaded automatically.');
    return;
  }
  if (!CONFIG.enable3d || !canvasEl || prefersReducedMotion) {
    report(prefersReducedMotion ? '3D animation is disabled by your device’s reduced-motion preference.' : 'Enable the 3D experience in this section’s settings.');
    if (loaderEl) loaderEl.classList.add('is-hidden');
    if (stages.s1) { stages.s1.style.opacity = '1'; stages.s1.style.visibility = 'visible'; }
  } else {

  /* ==========================================================
     WAIT FOR ALL DEPENDENCIES
     ========================================================== */

  function waitForDeps(cb) {
    ensureDependencies().then(function(libs) {
      if (destroyed || !section.isConnected) return;
      THREE = libs.THREE; gsap = libs.gsap; ScrollTrigger = libs.ScrollTrigger;
      try { cb(); } catch (error) { report('3D initialization failed: ' + error.message); }
    }).catch(function(error) { if (!destroyed) report(error.message); });
  }

  var initObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        initObserver.disconnect();
        waitForDeps(function() {
          gsap.registerPlugin(ScrollTrigger);
          ScrollTrigger.config({ ignoreMobileResize: true });
          initThreeScene();
        });
      }
    });
  }, { rootMargin: '1500px' });

  initObserver.observe(section);

  /* ==========================================================
     THREE.JS SCENE
     ========================================================== */

  function initThreeScene() {

    var isMobile = window.innerWidth < 768;
    var pixelRatio = Math.min(window.devicePixelRatio, isMobile ? 1.25 : 1.5);

    /* ---- Renderer ---- */
    var renderer = new THREE.WebGLRenderer({
      canvas: canvasEl,
      antialias: true,
      alpha: false,
      powerPreference: 'high-performance'
    });
    renderer.setPixelRatio(pixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x181818, 1);
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.2;

    /* ---- Scene ---- */
    var scene = new THREE.Scene();
    scene.background = new THREE.Color(0x181818);

    /* ---- Camera ---- */
    var camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.set(0, 0, 120);
    camera.lookAt(0, 0, 0);

    /* ---- Lights ---- */
    var ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);

    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.5);
    scene.add(hemisphereLight);

    var keyLight = new THREE.DirectionalLight(0xffffff, 1.4);
    keyLight.position.set(30, 40, 50);
    scene.add(keyLight);

    var fillLight = new THREE.DirectionalLight(0xffffff, 0.6);
    fillLight.position.set(-30, -10, 30);
    scene.add(fillLight);

    var backLight = new THREE.DirectionalLight(0xffffff, 0.4);
    backLight.position.set(0, 10, -50);
    scene.add(backLight);

    /* Neutral edge light */
    var rimLight = new THREE.DirectionalLight(0xffffff, 0.3);
    rimLight.position.set(-40, 20, -30);
    scene.add(rimLight);

    /* ---- Model container ---- */
    var modelSize = new THREE.Vector3();
    var baseScale = 1;
    var motion = { reveal: 0, scale: 1, right: 1, tilt: 1, back: 0, ports: 0, dark: 0, front: 0, birdView: 0, soundVisual: 0, soundWaves: 0, headGone: 0 };
    var modelYOffset = 0;
    var birdViewYOffset = 0;
    var rightOffset = 0;
    var timeline;
    var canvasWrap = section.querySelector('.skylive-3d-tv__canvas-wrap');
    var TV_ROOT = new THREE.Group();
    scene.add(TV_ROOT);

    /* ---- Part classification ---- */

    var parts = { all: [] };

    var modelCenter = new THREE.Vector3();

    /* ---- Load GLB ---- */
    var loader = new THREE.GLTFLoader();
    var dracoLoader = new THREE.DRACOLoader();
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/');
    dracoLoader.setDecoderConfig({ type: 'js' });
    loader.setDRACOLoader(dracoLoader);

    var glbUrl = CONFIG.glbUrl;
    if (!glbUrl) {
      console.warn('[Skylive3D] No GLB URL');
      if (loaderEl) loaderEl.classList.add('is-hidden');
      if (stages.s1) { stages.s1.style.opacity = '1'; stages.s1.style.visibility = 'visible'; }
      return;
    }

    if (DEBUG_3D) console.log('[Skylive3D] Loading GLB:', glbUrl);
    loader.load(
      glbUrl,
      function onLoad(gltf) {
        if (DEBUG_3D) console.log('[Skylive3D] GLB loaded, children:', gltf.scene.children.length);
        if (destroyed) {
          gltf.scene.traverse(function(mesh) {
            if (mesh.geometry) mesh.geometry.dispose();
            if (mesh.material) (Array.isArray(mesh.material) ? mesh.material : [mesh.material]).forEach(function(material) {
              Object.keys(material).forEach(function(key) { if (material[key] && material[key].isTexture) material[key].dispose(); });
              material.dispose();
            });
          });
          return;
        }
        try { processModel(gltf); section.dataset.status = 'ready'; }
        catch (error) { report('Model initialization failed: ' + error.message); }
      },
      function onProgress(xhr) {
        if (xhr.total && DEBUG_3D) {
          var pct = Math.round(xhr.loaded / xhr.total * 100);
          if (pct % 25 === 0) console.log('[Skylive3D] Loading:', pct + '%');
        }
      },
      function onError(err) {
        report('The GLB could not load. Check the GLB file URL is a public HTTPS model file, not a local path or Shopify admin link. ' + (err.message || '')); 
        if (loaderEl) loaderEl.classList.add('is-hidden');
        if (stages.s1) { stages.s1.style.opacity = '1'; stages.s1.style.visibility = 'visible'; }
      }
    );

    /* ==========================================================
       PROCESS MODEL
       ========================================================== */

    function processModel(gltf) {
      var model = gltf.scene;

      TV_ROOT.add(model);

      /* Preserve every mesh and its original materials. */
      /* Center and scale */
      var bbox = new THREE.Box3().setFromObject(TV_ROOT);
      bbox.getCenter(modelCenter);
      model.position.sub(modelCenter);

      setupCalloutAnchors(model);
      setupPortCamera(model);
      var bboxSize = new THREE.Vector3();
      bbox.getSize(bboxSize);
      var maxDim = Math.max(bboxSize.x, bboxSize.y, bboxSize.z);
      var targetSize = 60;
      var autoScale = targetSize / maxDim;
      var userScale = isMobile ? CONFIG.mobileScale : CONFIG.modelScale;
      TV_ROOT.scale.setScalar(autoScale * userScale);

      var yOff = isMobile ? CONFIG.mobileY : CONFIG.modelY;
      TV_ROOT.position.y = yOff;

      modelSize.copy(bboxSize).multiplyScalar(autoScale);
      baseScale = autoScale;
      fitViewport();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function() { if (!destroyed) fitViewport(); });
      if (DEBUG_3D) console.log('[Skylive3D] Model ready. Parts:', parts.all.length, '| Scale:', TV_ROOT.scale.x.toFixed(3));

      /* Hide loader, start rendering */
      if (loaderEl) loaderEl.classList.add('is-hidden');
      startRenderLoop();
      requestAnimationFrame(function() { if (!destroyed) buildScrollTimeline(); });
    }

    /* ==========================================================
       RENDER LOOP
       ========================================================== */

    // Mi13 is the supplied GLB's front assembly. Its broad, thin primitive is
    // the display; the deeper primitive contains the surrounding outer frame.
    var callouts = [];
    var projectedPoint = new THREE.Vector3();
    function setupCalloutAnchors(model) {
      TV_ROOT.updateWorldMatrix(true, true);
      var front = [];
      model.traverse(function(mesh) {
        if (!mesh.isMesh) return;
        var node = mesh, belongs = false;
        while (node && node !== model) {
          if (/^Mi13(?:_|$)/.test(node.name)) belongs = true;
          node = node.parent;
        }
        if (belongs) {
          var box = new THREE.Box3().setFromObject(mesh);
          front.push({ mesh: mesh, box: box, size: box.getSize(new THREE.Vector3()) });
        }
      });
      front.sort(function(a, b) { return a.size.z - b.size.z; });
      if (front.length < 2) {
        console.warn('[Skylive3D] Front assembly not identified; callout lines hidden.');
        return;
      }
      var display = front[0], frame = front[front.length - 1];
      var ray = new THREE.Raycaster();
      function attach(surface, x, y, name, element) {
        ray.set(new THREE.Vector3(x, y, frame.box.max.z + frame.size.length()), new THREE.Vector3(0, 0, -1));
        var hit = ray.intersectObject(surface.mesh, false)[0];
        if (!hit) {
          console.warn('[Skylive3D] No surface intersection for ' + name);
          return;
        }
        var anchor = new THREE.Object3D();
        anchor.name = name;
        anchor.position.copy(surface.mesh.worldToLocal(hit.point.clone()));
        surface.mesh.add(anchor);
        var svg = section.querySelector('.skylive-3d-tv__anchor-lines');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        var dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('r', '2');
        svg.appendChild(path); svg.appendChild(dot);
        callouts.push({ anchor: anchor, element: element, path: path, dot: dot });
      }
      // Raycast into the narrow left frame strip, outside the display bounds.
      attach(frame, (frame.box.min.x + display.box.min.x) / 2,
        display.box.max.y - display.size.y * .08, 'BEZEL_ANCHOR', stages.s3);
      attach(display, display.box.min.x + display.size.x * .22,
        display.box.min.y + display.size.y * .52, 'DISPLAY_ANCHOR', stages.s5);
    }

    function updateCalloutAnchors() {
      if (!callouts.length) return;
      TV_ROOT.updateWorldMatrix(true, true);
      camera.updateMatrixWorld();
      var bounds = viewportEl.getBoundingClientRect();
      var canvasBounds = canvasEl.getBoundingClientRect();
      var svg = section.querySelector('.skylive-3d-tv__anchor-lines');
      svg.setAttribute('viewBox', '0 0 ' + bounds.width + ' ' + bounds.height);
      callouts.forEach(function(item) {
        item.anchor.getWorldPosition(projectedPoint).project(camera);
        var x = canvasBounds.left - bounds.left + (projectedPoint.x * .5 + .5) * canvasBounds.width;
        var y = canvasBounds.top - bounds.top + (-projectedPoint.y * .5 + .5) * canvasBounds.height;
        // Align desktop heading rules with their own projected surface point.
        if (!isMobile) {
          var heading = item.element.querySelector('h3');
          item.element.style.top = (y - heading.offsetHeight - 8) + 'px';
        }
        if (!isMobile && item.element === stages.s5) {
          // Only move the display block; leave mesh anchors and bezel untouched.
          // On mobile retain its below-TV placement, with this minimum copy gap.
          var gap = parseFloat(getComputedStyle(item.element).rowGap);
          var minimumTop = stages.s3.offsetTop + stages.s3.offsetHeight + gap;
          item.element.style.top = Math.max(item.element.offsetTop, minimumTop) + 'px';
        }
        var origin = item.element.querySelector('.skylive-3d-tv__connector').getBoundingClientRect();
        var sx = origin.left - bounds.left;
        var sy = origin.top - bounds.top;
        var style = getComputedStyle(item.element);
        var visible = projectedPoint.z >= -1 && projectedPoint.z <= 1 && x >= 0 && x <= bounds.width && y >= 0 && y <= bounds.height;
        var opacity = visible && style.visibility !== 'hidden' ? style.opacity : '0';
        // Mobile routes through the left gutter, avoiding the stacked copy.
        var d = 'M ' + sx + ' ' + sy;
        if (isMobile) {
          var gutter = Math.max(4, sx - 12);
          d += ' L ' + gutter + ' ' + sy + ' L ' + gutter + ' ' + y;
        } else if (item.element === stages.s5 && Math.abs(sy - y) > 1) {
          // Keep the rule with the heading, then connect to the unchanged endpoint.
          var elbow = x - Math.min(32, Math.max(0, (x - sx) * .15));
          d += ' L ' + elbow + ' ' + sy;
        }
        d += ' L ' + x + ' ' + y;
        item.path.setAttribute('d', d);
        item.path.style.opacity = opacity;
        item.dot.setAttribute('cx', x); item.dot.setAttribute('cy', y);
        item.dot.style.opacity = opacity;
      });
    }

    var portLocalBounds = new THREE.Box3();
    var portWorldBounds = new THREE.Box3();
    var portFocus = new THREE.Vector3();
    var cameraFocus = new THREE.Vector3();
    var closeCamera = new THREE.Vector3();
    var fullCamera = new THREE.Vector3();
    var portViewDirection = new THREE.Vector3(1, -.6, 1.4).normalize();
    var portViewRight = new THREE.Vector3().crossVectors(new THREE.Vector3(0, 1, 0), portViewDirection).normalize();
    var portViewUp = new THREE.Vector3().crossVectors(portViewDirection, portViewRight).normalize();
    var portCorner = new THREE.Vector3();
    var portRelative = new THREE.Vector3();
    var baseCameraDistance = 120;
    var portReady = false;
    var originalKeyPosition = keyLight.position.clone();
    scene.add(keyLight.target);

    function setupPortCamera(model) {
      var names = /^(Object_078|Object_079|Box1_usb002|Box5_usb003|Box6_usb004|polySurface336|pPipe034|polySurface337|polySurface339|polySurface340|polySurface341)(?:_|$)/;
      TV_ROOT.updateWorldMatrix(true, true);
      var meshCount = 0;
      model.traverse(function(mesh) {
        if (!mesh.isMesh) return;
        var node = mesh, matches = false;
        while (node && node !== model) {
          if (names.test(node.name)) matches = true;
          node = node.parent;
        }
        if (!matches) return;
        // At setup TV_ROOT is identity; these are centered, unscaled root bounds.
        portLocalBounds.union(new THREE.Box3().setFromObject(mesh));
        meshCount++;
      });
      portReady = meshCount > 0 && !portLocalBounds.isEmpty();
      if (!portReady) console.warn('[Skylive3D] Connectivity meshes not found; retaining full back view.');
    }

    function updatePortCamera() {
      var progress = portReady ? motion.ports : 0;
      fullCamera.set(0, 0, baseCameraDistance);
      if (progress > 0) {
        TV_ROOT.updateWorldMatrix(true, true);
        portWorldBounds.copy(portLocalBounds).applyMatrix4(TV_ROOT.matrixWorld);
        portWorldBounds.getCenter(portFocus);
        var tan = Math.tan(camera.fov * Math.PI / 360);
        var fill = isMobile ? .68 : .76;
        var distance = 0;
        // Fit all eight bounds corners in the angled camera frustum with margin.
        for (var i = 0; i < 8; i++) {
          portCorner.set(i & 1 ? portWorldBounds.max.x : portWorldBounds.min.x,
            i & 2 ? portWorldBounds.max.y : portWorldBounds.min.y,
            i & 4 ? portWorldBounds.max.z : portWorldBounds.min.z);
          portRelative.copy(portCorner).sub(portFocus);
          var depth = portRelative.dot(portViewDirection);
          distance = Math.max(distance,
            depth + Math.abs(portRelative.dot(portViewRight)) / (tan * camera.aspect * fill),
            depth + Math.abs(portRelative.dot(portViewUp)) / (tan * fill));
        }
        closeCamera.copy(portFocus).addScaledVector(portViewDirection, distance);
        camera.position.lerpVectors(fullCamera, closeCamera, progress);
        cameraFocus.copy(portFocus).multiplyScalar(progress);
      } else {
        // Orbit the camera above the product without translating or rotating the TV.
        // Keeping the orbit on the world YZ plane preserves its right-side framing.
        var elevation = motion.birdView * Math.PI * .36;
        var orbitDistance = baseCameraDistance * (1 + .16 * motion.birdView);
        camera.position.set(0, Math.sin(elevation) * orbitDistance,
          Math.cos(elevation) * orbitDistance);
        cameraFocus.set(0, 0, 0);
      }
      camera.lookAt(cameraFocus);
      // Neutral close-up key, reverting exactly when scrolling back.
      keyLight.position.lerpVectors(originalKeyPosition, camera.position, progress);
      keyLight.target.position.copy(cameraFocus);
      keyLight.intensity = 1.4 + 3 * progress;
      fillLight.intensity = .6 + .8 * progress;
      camera.updateMatrixWorld();
    }

    var connectivityLeft = section.querySelector('[data-connectivity="entertainment"]');
    var connectivityRight = section.querySelector('[data-connectivity="devices"]');
    var connectivityProjection = new THREE.Vector3();
    var whiteBackground = new THREE.Color(0xffffff);
    var darkBackground = new THREE.Color(0x111111);
    function updateConnectivityStory() {
      scene.background.set(0x181818);
      var background = '#' + scene.background.getHexString();
      renderer.setClearColor(scene.background, 1);
      viewportEl.style.backgroundColor = background;
      canvasWrap.style.backgroundColor = background;
      if (!portReady) return;
      var width = viewportEl.clientWidth, height = viewportEl.clientHeight;
      var canvasRect = canvasEl.getBoundingClientRect();
      var viewportRect = viewportEl.getBoundingClientRect();
      var minX = width, maxX = 0, minY = height, maxY = 0;
      // Use the already-established port bounds; never alter the stage-7 camera.
      for (var i = 0; i < 8; i++) {
        connectivityProjection.set(i & 1 ? portWorldBounds.max.x : portWorldBounds.min.x,
          i & 2 ? portWorldBounds.max.y : portWorldBounds.min.y,
          i & 4 ? portWorldBounds.max.z : portWorldBounds.min.z).project(camera);
        var x = canvasRect.left - viewportRect.left + (connectivityProjection.x * .5 + .5) * canvasRect.width;
        var y = canvasRect.top - viewportRect.top + (-connectivityProjection.y * .5 + .5) * canvasRect.height;
        minX = Math.min(minX, x); maxX = Math.max(maxX, x);
        minY = Math.min(minY, y); maxY = Math.max(maxY, y);
      }
      var padding = width < 768 ? 18 : Math.max(24, width * .035);
      if (width < 768) {
        [connectivityLeft, connectivityRight].forEach(function(block) {
          block.style.left = padding + 'px'; block.style.width = (width - padding * 2) + 'px';
        });
        connectivityLeft.style.top = Math.max(mobileTextSafeTop, maxY + 24) + 'px';
        connectivityRight.style.top = Math.max(mobileTextSafeTop, maxY + 24) + 'px';
        // Reuse the below-port text slot as the next mobile feature fades in.
        connectivityLeft.style.filter = 'opacity(' + (1 - parseFloat(getComputedStyle(connectivityRight).opacity || 0)) + ')';
      } else {
        connectivityLeft.style.removeProperty('filter');
        var leftWidth = Math.min(260, Math.max(140, minX - padding - 22));
        var rightWidth = Math.min(260, Math.max(140, width - maxX - padding - 22));
        connectivityLeft.style.left = padding + 'px';
        connectivityLeft.style.width = leftWidth + 'px';
        connectivityRight.style.left = (width - padding - rightWidth) + 'px';
        connectivityRight.style.width = rightWidth + 'px';
        var centerY = (minY + maxY) / 2;
        connectivityLeft.style.top = Math.max(24, centerY - connectivityLeft.offsetHeight / 2) + 'px';
        connectivityRight.style.top = Math.max(24, centerY - connectivityRight.offsetHeight / 2) + 'px';
      }
    }





    // A single transparent water field; every movement follows scroll.
    var soundBehind = new THREE.Vector3();
    var soundMaterial = new THREE.ShaderMaterial({
      transparent: true, depthWrite: false, side: THREE.DoubleSide,
      uniforms: { reveal: { value: 0 }, progress: { value: 0 } },
      vertexShader: 'varying vec2 waveUV; void main(){waveUV=uv;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);}',
      fragmentShader: `
        varying vec2 waveUV;
        uniform float reveal;
        uniform float progress;
        void main(){
          vec2 p=(waveUV-.5)*2.0;
          p.y*=1.13;
          float r=length(p), a=atan(p.y,p.x);
          vec3 ink=vec3(.85,.96,.97);
          float alpha=0.0;
          for(int i=0;i<9;i++){
            float f=float(i);
            float travel=smoothstep(f*.047,f*.047+.58,progress);
            float radius=.075+f*.074+travel*(.10+f*.014);
            float warp=sin(a*3.0+f*.64+progress*1.7)*.019;
            warp+=sin(a*7.0-f*.47-progress*.8)*.010;
            warp+=sin(a*11.0+f*.81)*.004;
            float d=r-radius-warp*(.45+radius);
            float width=.012+.005*sin(a*4.0+f)+f*.001;
            float ribbon=exp(-pow(d/width,2.0));
            float wash=exp(-pow((d+.018)/(.038+f*.003),2.0));
            float crest=exp(-pow((d-.010)/.005,2.0));
            float strength=(.22+.60*travel)*(1.0-f*.058);
            float layer=(ribbon*.40+wash*.12)*strength;
            vec3 ocean=mix(vec3(.0,.42,.56),vec3(.15,.77,.85),.5+.5*sin(a*2.0+f*.8));
            ocean=mix(ocean,vec3(.56,.91,.93),crest*.75);
            float nextAlpha=alpha+layer*(1.0-alpha);
            ink=mix(ink,ocean,layer/max(nextAlpha,.001));
            alpha=nextAlpha;
          }
          float edge=1.0-smoothstep(.86,1.0,r);
          gl_FragColor=vec4(ink,alpha*reveal*edge);
        }`
    });
    var soundGroup = new THREE.Mesh(new THREE.PlaneGeometry(112,112), soundMaterial);
    soundGroup.visible=false;
    soundGroup.renderOrder=-2;
    scene.add(soundGroup);
    function updateSoundStory(){
      soundGroup.visible=motion.soundVisual>.001;
      if(!soundGroup.visible) return;
      camera.getWorldDirection(soundBehind).negate();
      soundGroup.position.copy(TV_ROOT.position);
      if (!isMobile) soundGroup.position.y-=modelSize.y*.08;
      soundGroup.position.addScaledVector(soundBehind,-16);
      soundGroup.quaternion.copy(camera.quaternion);
            if (isMobile) {
        var distance = soundGroup.position.distanceTo(camera.position);
        var worldDiameter = mobileSoundDiameter * (2 * distance * Math.tan(camera.fov * Math.PI / 360) / viewportEl.clientHeight);
        soundGroup.scale.setScalar(worldDiameter / 112 * (.78 + motion.soundWaves * .22));
      } else soundGroup.scale.setScalar(.66+motion.soundWaves*.34);
      soundMaterial.uniforms.reveal.value=motion.soundVisual;
      soundMaterial.uniforms.progress.value=motion.soundWaves;
    }


    var mobileTextSafeTop = 20;
    function updateMobileHeaderSafeArea() {
      if (!isMobile) {
        viewportEl.style.removeProperty('--mobile-text-safe-top');
        return;
      }
      var viewportRect = viewportEl.getBoundingClientRect();
      // Measure the header against the screen top (where the pinned section sits),
      // never against the section's scroll position. Otherwise, once the section
      // scrolls up, the header looks ~1000px tall and the TV is pushed to the bottom.
      var headerBottom = 0;
      document.querySelectorAll('header, sticky-header, #shopify-section-header, .shopify-section-group-header-group, .header-wrapper, [id*="shopify-section"][id*="header"]').forEach(function(header) {
        if (section.contains(header)) return;
        var rect = header.getBoundingClientRect();
        var style = getComputedStyle(header);
        if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return;
        if (rect.width > 0 && rect.height > 0 && rect.height < window.innerHeight * .5 &&
            rect.bottom > 0 && rect.top < window.innerHeight * .25 &&
            rect.right > viewportRect.left && rect.left < viewportRect.right) {
          headerBottom = Math.max(headerBottom, rect.bottom);
        }
      });
      mobileTextSafeTop = Math.min(window.innerHeight * .3, Math.max(20, headerBottom + 20));
      viewportEl.style.setProperty('--mobile-text-safe-top', mobileTextSafeTop + 'px');
    }

    var mobileFeaturePoint = new THREE.Vector3();
    // Mobile layout slots, measured in fitViewport().
    var mobileSlots = { s3: 0, s5: 0, sound: 0, textTop: 0, offHead: 0, offNoHead: 0 };
    var MOBILE_BOTTOM_PAD = 32;
    function updateMobileFeatureLayout() {
      if (!isMobile) return;
      // Text ends just above the bottom edge, so the next section follows right after it.
      stages.s3.style.top = mobileSlots.s3 + 'px';
      stages.s5.style.top = mobileSlots.s5 + 'px';
      // TV sits centred between heading and text; once the heading fades it eases up.
      var off = mobileSlots.offHead + (mobileSlots.offNoHead - mobileSlots.offHead) * motion.headGone;
      var w = viewportEl.clientWidth, h = viewportEl.clientHeight;
      if (!camera.view || !camera.view.enabled || Math.abs(camera.view.offsetY - off) > .25 || camera.view.fullHeight !== h || camera.view.fullWidth !== w) {
        camera.setViewOffset(w, h, 0, off, w, h);
        camera.updateProjectionMatrix();
      }
    }

    function bottomOfMobileTV() { return parseFloat(stages.s5.style.top) - 30; }
    var mobileSoundCopy = section.querySelector('[data-sound-copy]');
    var mobileSoundDiameter = 0;
    function updateMobileSoundLayout() {
      if (!isMobile) {
        if (camera.view && camera.view.enabled) camera.clearViewOffset();
        mobileSoundCopy.style.removeProperty('top');
        return;
      }
      var h = viewportEl.clientHeight, w = viewportEl.clientWidth;
      var safeTop = mobileTextSafeTop;

      // Waves fill the space between the header and the text; copy sits at the bottom.
      mobileSoundDiameter = Math.min(w * 1.02, Math.max(120, mobileSlots.textTop - safeTop + 30));
      mobileSoundCopy.style.top = mobileSlots.sound + 'px';
    }




    var renderRunning = false;
    var modelReady = false;
    var onScreen = true;
    var frameCount = 0;
    var visObserver = new IntersectionObserver(function(entries) {
      onScreen = entries[0].isIntersecting;
      if (onScreen && modelReady) startRenderLoop();
    }, { rootMargin: '100px' });
    visObserver.observe(section);

    function startRenderLoop() {
      modelReady = true;
      if (renderRunning) return;
      renderRunning = true;

      function render() {
        if (!renderRunning) return;
        if (!onScreen) { renderRunning = false; return; }
        frameCount++;
        TV_ROOT.scale.setScalar(baseScale * motion.scale);
        TV_ROOT.position.x = rightOffset * motion.right;
        // Slight three-quarter angle: left edge closer, matching the reference.
        // Share the movement progress so tilt scrubs and reverses with stage 3.
        TV_ROOT.rotation.y = (isMobile ? 0 : (Math.PI / 180) * 18 * motion.right * motion.tilt * (1 - motion.front)) + Math.PI * motion.back;
        var baseModelY = modelYOffset * (1 - motion.back);
        TV_ROOT.position.y = isMobile ? 0 : modelYOffset * (1 - Math.max(motion.back, motion.front));
        updatePortCamera();
        // Header lookup is expensive; checking a few times a second is enough.
        if (frameCount % 15 === 1) updateMobileHeaderSafeArea();
        updateMobileFeatureLayout();
        updateMobileSoundLayout();
        updateCalloutAnchors();
        updateConnectivityStory();
        updateSoundStory();
        renderer.render(scene, camera);
        requestAnimationFrame(render);
      }
      render();
    }

    /* ==========================================================
       SCROLL TIMELINE
       ========================================================== */

    function buildScrollTimeline() {
      gsap.set(canvasWrap, { autoAlpha: 0 });
      timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: viewportEl, start: 'top top',
          end: function() { return '+=' + (viewportEl.clientWidth < 768 ? 3.25 * .89 * window.innerHeight : (viewportEl.clientWidth < 1024 ? 3.75 : 4) * .89 * viewportEl.clientHeight); },
          pin: true, pinSpacing: true, scrub: 0.3, anticipatePin: 1,
          invalidateOnRefresh: true, onRefresh: fitViewport
        }
      });
      gsap.set(stages.s1, { autoAlpha: 1, y: 0 });
      gsap.set(stages.s3, { autoAlpha: 0, y: 0 });
      timeline.addLabel('intro', 0);
      // The heading fades as you scroll into Bezel Less Design; on mobile the TV moves up into its space.
      timeline.to(stages.s1, { autoAlpha: 0, duration: 1.5 }, 0);
      if (viewportEl.clientWidth < 768) timeline.to(motion, { headGone: 1, duration: 1.5, ease: 'power2.inOut' }, 0);
      // Reveal the already-positioned TV; no scale, travel or tilt animation.
      timeline.to(canvasWrap, { autoAlpha: 1, duration: 1.5 }, 0.5);
      timeline.addLabel('bezel', 8);
      timeline.to(stages.s3, { autoAlpha: 1, y: 0, duration: 1.5 }, 0.5);
      timeline.to(stages.s3, { autoAlpha: 0, duration: 2 }, 14);
      timeline.addLabel('display', 15);
      timeline.fromTo(stages.s5, { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: 2 }, 15);
      timeline.to(stages.s5, { autoAlpha: 0, duration: 2 }, 20);
      timeline.addLabel('turnToBack', 22);
      timeline.to(motion, { right: 0, back: 1, duration: 8, ease: 'power2.inOut' }, 22);
      timeline.addLabel('connectivity', 30);
      timeline.to(motion, { ports: 1, duration: 8, ease: 'power2.inOut' }, 30);
      timeline.addLabel('entertainment', 38);
      timeline.fromTo(connectivityLeft, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 2 }, 38);
      timeline.addLabel('devices', 44);
      timeline.fromTo(connectivityRight, { autoAlpha: 0, x: 30 }, { autoAlpha: 1, x: 0, duration: 2 }, 44);
      timeline.addLabel('zoomOut', 50);
      timeline.to([connectivityLeft, connectivityRight], { autoAlpha: 0, duration: 1.5 }, 50);
      timeline.to(motion, { ports: 0, duration: 6, ease: 'power2.inOut' }, 50);
      timeline.addLabel('turnFront', 56);
      timeline.to(motion, { back: 0, right: 1, front: 1, duration: 8, ease: 'power2.inOut' }, 56);
      timeline.addLabel('birdView', 64);
      timeline.to(motion, { birdView: 1, duration: 5.5, ease: 'power2.inOut' }, 64);
      timeline.addLabel('soundIntro', 70);
      timeline.to(motion, { soundVisual: 1, duration: 4, ease: 'power1.inOut' }, 70);
      timeline.addLabel('soundWaves', 74);
      timeline.to(motion, { soundWaves: .85, duration: 8, ease: 'power1.inOut' }, 74);
      timeline.addLabel('soundInfo', 82);
      var soundCopy = section.querySelector('[data-sound-copy]');
      timeline.set(soundCopy, { autoAlpha: 1 }, 82);
      timeline.fromTo(soundCopy.querySelector('h3'), { autoAlpha: 0, x: -30 }, { autoAlpha: 1, x: 0, duration: 2 }, 82);
      timeline.fromTo(soundCopy.querySelector('.skylive-sound-copy__divider'), { scaleX: 0 }, { scaleX: 1, duration: 2 }, 83);
      timeline.fromTo(soundCopy.querySelector('p'), { autoAlpha: 0, x: -20 }, { autoAlpha: 1, x: 0, duration: 2 }, 84);
      timeline.to(motion, { soundWaves: 1, duration: 7 }, 82);



      ScrollTrigger.refresh();
    }

    function fitViewport() {
      var width = viewportEl.clientWidth;
      var height = viewportEl.clientHeight;
      isMobile = width < 768;
      updateMobileHeaderSafeArea();
      camera.aspect = width / height;
      // Fit the complete asset; reserve the left half on desktop without clipping.
      // Mobile: TV never wider than 92% of the screen, so its sides are never cut.
      var desiredWidth = isMobile ? .92 * CONFIG.mobileScale / .7 : .54 * CONFIG.modelScale;
      desiredWidth = Math.min(isMobile ? .92 : .56, desiredWidth);
      var tan = Math.tan(camera.fov * Math.PI / 360);
      var distance = Math.max(modelSize.x / (2 * tan * camera.aspect * desiredWidth), modelSize.y / (2 * tan * .72)) + modelSize.z / 2;
      camera.position.set(0, 0, distance);
      baseCameraDistance = distance;
      camera.far = Math.max(1000, distance * 4);
      camera.clearViewOffset();
      camera.updateProjectionMatrix();
      stages.s1.style.removeProperty('padding-top');
      if (isMobile) {
        // Heading right under the header, text anchored to the bottom, TV centred between.
        var safeTop = mobileTextSafeTop || 20;
        stages.s1.style.paddingTop = safeTop + 'px';
        var headH = stages.s1.querySelector('.skylive-3d-tv__text-block').offsetHeight;
        var soundEl = section.querySelector('[data-sound-copy]');
        var textH = Math.max(stages.s3.offsetHeight, stages.s5.offsetHeight, soundEl.offsetHeight);
        var headBottom = safeTop + headH;
        var textTop = height - MOBILE_BOTTOM_PAD - textH;
        mobileSlots.s3 = Math.round(height - MOBILE_BOTTOM_PAD - stages.s3.offsetHeight);
        mobileSlots.s5 = Math.round(height - MOBILE_BOTTOM_PAD - stages.s5.offsetHeight);
        mobileSlots.sound = Math.round(height - MOBILE_BOTTOM_PAD - soundEl.offsetHeight);
        mobileSlots.textTop = textTop;

        var measureTV = function() {
          camera.position.set(0, 0, distance);
          camera.lookAt(0, 0, 0);
          camera.updateMatrixWorld();
          TV_ROOT.scale.setScalar(baseScale * motion.scale);
          TV_ROOT.updateWorldMatrix(true, true);
          var corner = new THREE.Vector3(), top = height, bottom = 0;
          for (var c = 0; c < 8; c++) {
            corner.set((c & 1 ? 1 : -1) * modelSize.x / (2 * baseScale),
              (c & 2 ? 1 : -1) * modelSize.y / (2 * baseScale),
              (c & 4 ? 1 : -1) * modelSize.z / (2 * baseScale))
              .applyMatrix4(TV_ROOT.matrixWorld).project(camera);
            var py = (.5 - corner.y * .5) * height;
            top = Math.min(top, py); bottom = Math.max(bottom, py);
          }
          return { top: top, bottom: bottom };
        };
        var tv = measureTV();
        // On short screens, shrink the TV so it never overlaps the heading or text.
        var room = textTop - headBottom - 32;
        if (tv.bottom - tv.top > room && room > 60) {
          distance *= (tv.bottom - tv.top) / room;
          baseCameraDistance = distance;
          camera.far = Math.max(1000, distance * 4);
          tv = measureTV();
        }
        var tvMid = (tv.top + tv.bottom) / 2;
        mobileSlots.offHead = tvMid - (headBottom + textTop) / 2;
        mobileSlots.offNoHead = tvMid - (safeTop + textTop) / 2;
        var startOff = mobileSlots.offHead + (mobileSlots.offNoHead - mobileSlots.offHead) * motion.headGone;
        camera.setViewOffset(width, height, 0, startOff, width, height);
        camera.updateProjectionMatrix();
      }
      var viewWidth = 2 * distance * tan * camera.aspect;
      rightOffset = isMobile ? 0 : viewWidth * .20;
      var pixelsY = isMobile ? CONFIG.mobileY : CONFIG.modelY;
      modelYOffset = -pixelsY * (2 * distance * tan / height);
      var viewHeight = 2 * distance * tan;
      var topMargin = viewHeight * (isMobile ? .12 : .075);
      birdViewYOffset = viewHeight * .5 - topMargin - modelSize.y * motion.scale * .5;
      var fittedBaseY = modelYOffset * (1 - motion.back);
      TV_ROOT.position.y = isMobile ? 0 : modelYOffset * (1 - Math.max(motion.back, motion.front));
      renderer.setSize(width, height);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, isMobile ? 1.25 : 1.5));
    }

    /* ==========================================================
       RESIZE HANDLER
       ========================================================== */

    var resizeTimeout;
    var lastResizeWidth = window.innerWidth;
    function onResize() {
      // Mobile browsers fire resize when the address bar hides/shows while scrolling.
      // Only re-layout when the width really changes (rotation, desktop resize).
      if (window.innerWidth === lastResizeWidth && window.innerWidth < 768) return;
      lastResizeWidth = window.innerWidth;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        fitViewport();
        ScrollTrigger.refresh();
      }, 250);
    }
    window.addEventListener('resize', onResize);

    /* ==========================================================
       SHOPIFY EDITOR
       ========================================================== */

    disposeScene = function() {
        visObserver.disconnect();
        renderRunning = false;
        clearTimeout(resizeTimeout);
        window.removeEventListener('resize', onResize);
        if (timeline) timeline.kill();
        dracoLoader.dispose();
        TV_ROOT.traverse(function(child) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            (Array.isArray(child.material) ? child.material : [child.material]).forEach(function(material) {
              Object.keys(material).forEach(function(key) { if (material[key] && material[key].isTexture) material[key].dispose(); });
              material.dispose();
            });
          }
        });
        renderer.dispose();
        ScrollTrigger.getAll().forEach(function(st) {
          if (st.trigger === viewportEl) st.kill();
        });
    };

  } /* end initThreeScene */

  } /* end else (3D enabled) */

  } // mount
  function scan(root) {
    if (root.matches && root.matches('.skylive-3d-tv')) mount(root);
    root.querySelectorAll('.skylive-3d-tv').forEach(mount);
  }
  window.SkyliveTVStory = { scan: scan };
  document.addEventListener('shopify:section:load', function(event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll('.skylive-3d-tv').forEach(function(section) { if (section._skyliveDestroy) section._skyliveDestroy(); });
  });
  document.addEventListener('shopify:section:reorder', function() { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { scan(document); }, { once: true });
  else scan(document);
})();

  } catch(e) { console.error(e); }
})();
})();
